import { useState } from 'react'
import Box from '@mui/material/Box'
import { useTheme } from '@mui/material/styles'
import { wrap } from 'popmotion'
import { AnimatePresence, motion } from 'framer-motion'
import arrow from '../1elements/Icons/png/arrow.png'
import { reExportedColors } from '../1elements'

const variants = {
  enter: direction => ({
    opacity: 0,
    x: direction > 0 ? 1000 : -1000
  }),
  center: {
    opacity: 1,
    x: 0,
    zIndex: 1
  },
  exit: direction => ({
    opacity: 0,
    x: direction < 0 ? 1000 : -1000,
    zIndex: 0
  })
}

const swipeConfidenceThreshold = 10000
const swipePower = (offset, velocity) => Math.abs(offset) * velocity

const ImageGallery = ({ images, className }) => {
  const theme = useTheme()
  const [[page, direction], setPage] = useState([0, 0])
  const imageIndex = wrap(0, images.length, page)
  const paginate = newDirection => {
    setPage([page + newDirection, newDirection])
  }
  const arrowStyle = {
    cursor: 'pointer',
    left: '5px',
    position: 'absolute',
    top: 'calc(50% - 10px)',
    width: '15px'
  }

  return (
    <Box className={className} sx={{
      alignItems: 'center',
      display: 'flex',
      flexDirection: 'column',
      height: '100%',
      justifyContent: 'space-around',
      width: '100%'
    }}>
      <Box sx={{ height: '80%', position: 'relative', width: '90%' }}>
        <AnimatePresence initial={false} custom={direction}>
          <motion.img
            key={page}
            src={images[imageIndex].fieldData}
            custom={direction}
            variants={variants}
            initial='enter'
            animate='center'
            exit='exit'
            transition={{
              x: { type: 'spring', stiffness: 300, damping: 30 },
              opacity: { duration: 0.2 }
            }}
            drag='x'
            dragConstraints={{ left: 0, right: 0 }}
            dragElastic={1}
            onDragEnd={(event, { offset, velocity }) => {
              const swipe = swipePower(offset.x, velocity.x)

              if (swipe < -swipeConfidenceThreshold) paginate(1)
              else if (swipe > swipeConfidenceThreshold) paginate(-1)
            }}
            alt='Image Not Found'
            style={{
              backgroundColor: reExportedColors.LIGHT_GREY,
              borderRadius: '23px',
              boxShadow: theme.boxShadow,
              fontFamily: 'Lato, sans-serif',
              fontWeight: '700',
              height: '100%',
              lineHeight: '24px',
              objectFit: 'cover',
              position: 'absolute',
              textAlign: 'center',
              width: '100%',
              zIndex: 0
            }}
          />
        </AnimatePresence>
        <img
          src={arrow}
          alt='Previous'
          style={arrowStyle}
          onClick={() => paginate(-1)}
        />
        <img
          src={arrow}
          alt='Next'
          style={{ ...arrowStyle, left: 'auto', right: '5px', transform: 'scale(-1)' }}
          onClick={() => paginate(1)}
        />
      </Box>
    </Box>
  )
}

export default ImageGallery
